<template>
    <el-dialog
        title
        width="80%"
        @close="closeDialog"
        :close-on-click-modal="false"
        class="leader-dialog"
        :visible.sync="dialogVisible"
    >
        <el-form :model="model" class="leader-style-form" :inline="true">
            <el-form-item label="开始时间">
                <el-date-picker
                    v-model="model.time"
                    type="date"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
                <el-date-picker
                    v-model="model.to_day"
                    type="date"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                ></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button @click="getWiringMeterDataList">查询</el-button>
            </el-form-item>
        </el-form>
        <div style="width:100%;height: 550px">
            <el-scrollbar style="width: 100%">
                <el-table class="leader-style-table" :data="datas" border style="width: 100%">
                    <el-table-column
                        v-for="item in headers"
                        :key="item.column_name"
                        :label="item.column_desc"
                        :prop="item.column_name"
                        width="160"
                    ></el-table-column>
                </el-table>
            </el-scrollbar>

            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" class="leader-common-button">取 消</el-button>
        </div>
    </el-dialog>
</template>
<script>
import * as api from "@/http/api.js";
export default {
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        id: {
            type: String
        }
    },
    watch: {
        dialogVisible(newVal) {
            this.getSysDate();
        }
    },
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            model: {
                time: "",
                to_day: ""
            },
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            headers: [],
            datas: []
        }
    },
    methods: {
        // 获取系统时间
        getSysDate() {
            api.getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    this.model.time = res.bus_json.sysdate;
                    this.model.to_day = res.bus_json.sysdate;
                    this.getWiringMeterDataList()
                }
            });
        },
        // 获取历史数据
        getWiringMeterDataList() {
            api.getWiringMeterDataList({ point_id: this.id, show_day: this.model.time, to_day: this.model.to_day, pageNum: this.pageNum, pageSize: this.pageSize }).then(res => {
                if (res && res.error_code == 0) {
                    this.headers = res.bus_json.headList;
                    this.datas = res.bus_json.dataList;
                    this.totalNum = res.bus_json.count;
                }
            })
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getWiringMeterDataList();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getWiringMeterDataList();
        },
        closeDialog() {
            this.dialogVisible = false;
            this.$emit("update:dialogVisible", this.dialogVisible);

        }
    }
}
</script>
<style lang="scss" >
.el-table__empty-block {
    width: 100% !important;
}
// 滚动条的宽度*/
.el-table__body-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 12px;
    background: #022d79;
}

// 滚动条的滑块*/
.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 3px;
}
</style>